import { BLIPDESK_ACTIVE, DESK_OWNER_IDENTITY, DEFAULT_PROVIDER, } from 'modules/application/detail/attendance/configuration/ConfigurationController';
import { SUCCESS_STATUS, FAILURE_STATUS } from 'modules/application/misc/SegmentService';
import { ToastType } from 'modules/application/misc/ToastService';
import * as styles from './blipdesk.module.scss';
import { AttendanceFeatures } from 'modules/application/detail/attendance/AttendanceFeatures';
export const LimeProvider = 'Lime';
export class BlipDeskController {
    static $inject = ['application', 'LoadingService', 'ConfigurationsService', 'SegmentService', 'ToastService', 'MESSAGINGHUBDOMAIN', 'BLIP_DESK_URL', 'BLIP_DESK_URL_TENANT', 'TenantService'];
    constructor(application, LoadingService, ConfigurationsService, SegmentService, ToastService, MESSAGINGHUBDOMAIN, BLIP_DESK_URL, BLIP_DESK_URL_TENANT, TenantService) {
        this.application = application;
        this.LoadingService = LoadingService;
        this.ConfigurationsService = ConfigurationsService;
        this.SegmentService = SegmentService;
        this.ToastService = ToastService;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
        this.blipDeskUrl = TenantService.addTenantPrefixToUrl(BLIP_DESK_URL_TENANT, this.application?.tenantId, BLIP_DESK_URL);
    }
    async $onInit() {
        await this.checkFeatures();
        this.styles = styles;
        this.configuration = {};
        this.loadConfiguration();
    }
    async checkFeatures() {
        this.isConfigurationsApplicationsDomainUsageGetEnabled = await AttendanceFeatures.isUseConfigurationsDomainOnAttendanceOperationsGetEnabled();
        this.isConfigurationsApplicationsDomainUsageSetEnabled = await AttendanceFeatures.isUseConfigurationsDomainOnAttendanceOperationsSetEnabled();
    }
    /**
     * Load bot's customer service channel configuration
     */
    async loadConfiguration() {
        try {
            this.LoadingService.startLoading();
            const configuration = await this.ConfigurationsService.get(`${DESK_OWNER_IDENTITY}.${this.MESSAGINGHUBDOMAIN}`, undefined, this.isConfigurationsApplicationsDomainUsageGetEnabled);
            this.configuration = { ...configuration };
            this.isActive =
                this.configuration[DEFAULT_PROVIDER] == LimeProvider
                    ? true
                    : false;
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    /**
     * Check if another customer service channel is connected
     *
     * @returns whether a channel other than BLiP Desk is connected or not
     */
    isOtherChannelConnected() {
        return this.configuration
            && this.configuration[DEFAULT_PROVIDER]
            && this.configuration[DEFAULT_PROVIDER] !== LimeProvider;
    }
    /**
     * If no other channel is connected, save configuration and activates BLiP Desk
     */
    async activateIntegration() {
        if (this.isOtherChannelConnected()) {
            this.isActive = false;
            this.ToastService.toast(ToastType.Danger, 'blipdesk.error.concurrence');
            return;
        }
        try {
            this.LoadingService.startLoading();
            this.configuration[DEFAULT_PROVIDER] = LimeProvider;
            this.configuration[BLIPDESK_ACTIVE] = true;
            await this.saveConfiguration();
            this.isActive = true;
            this.registerSuccessfulConnection();
        }
        catch (e) {
            delete this.configuration[DEFAULT_PROVIDER];
            this.configuration[BLIPDESK_ACTIVE] = false;
            this.isActive = true;
            this.registerFailedConnection();
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    /**
     * Delete configuration default customer service channel
     */
    async deleteIntegration() {
        try {
            this.LoadingService.startLoading();
            delete this.configuration[DEFAULT_PROVIDER];
            await this.ConfigurationsService.deleteSingle(`${DESK_OWNER_IDENTITY}.${this.MESSAGINGHUBDOMAIN}`, DEFAULT_PROVIDER, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled);
            this.configuration[BLIPDESK_ACTIVE] = false;
            await this.saveConfiguration();
            this.isActive = false;
            this.registerSuccessfulDisconnection();
        }
        catch (e) {
            this.isActive = true;
            this.configuration[DEFAULT_PROVIDER] = LimeProvider;
            this.configuration[BLIPDESK_ACTIVE] = true;
            this.registerFailedDisconnection();
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    /**
     * Save bot's customer service configuration
     */
    async saveConfiguration() {
        await this.ConfigurationsService.set(`${DESK_OWNER_IDENTITY}.${this.MESSAGINGHUBDOMAIN}`, this.configuration, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled);
    }
    /**
     * On switch trigger, activate or delete BLiP Desk integration
     *
     * @param value - new boolean value for cache
     */
    onSwitch(value) {
        this.isActive = value;
        if (this.isActive) {
            this.activateIntegration();
        }
        else {
            this.deleteIntegration();
        }
    }
    /**
     * Register successful connection, with toast and segment events
     */
    registerSuccessfulConnection() {
        try {
            this.ToastService.toast(ToastType.Success, 'blipdesk.success.connection');
            this.SegmentService.createBotTrack('helpdesk-integrations-blipdesk-connected', this.application, { status: SUCCESS_STATUS });
            this.SegmentService.setAccount({ customerServiceChannel: 'BLiP Desk' });
        }
        catch (e) { } //Not necessary error handling
    }
    /**
     * Register failed connection, with toast and segment events
     */
    registerFailedConnection() {
        try {
            this.ToastService.toast(ToastType.Danger, 'blipdesk.error.connection');
            this.SegmentService.createBotTrack('helpdesk-integrations-blipdesk-connected', this.application, { status: FAILURE_STATUS });
        }
        catch (e) { } //Not necessary error handling
    }
    /**
     * Register successful disconnection, with toast and segment events
     */
    registerSuccessfulDisconnection() {
        try {
            this.ToastService.toast(ToastType.Success, 'blipdesk.success.disconnection');
            this.SegmentService.createBotTrack('helpdesk-integrations-blipdesk-disabled', this.application, { status: SUCCESS_STATUS });
            this.SegmentService.setAccount({ customerServiceChannel: 'None' });
        }
        catch (e) { } //Not necessary error handling
    }
    /**
     * Register failed disconnection, with toast and segment events
     */
    registerFailedDisconnection() {
        try {
            this.ToastService.toast(ToastType.Danger, 'blipdesk.error.disconnection');
            this.SegmentService.createBotTrack('helpdesk-integrations-blipdesk-disabled', this.application, { status: FAILURE_STATUS });
        }
        catch (e) { } //Not necessary error handling
    }
}
BlipDeskController.$inject = ['application', 'LoadingService', 'ConfigurationsService', 'SegmentService', 'ToastService', 'MESSAGINGHUBDOMAIN', 'BLIP_DESK_URL', 'BLIP_DESK_URL_TENANT', 'TenantService'];
